import _ from "lodash";
import $ from "jquery";
import i18n from "i18next";
import "react-dropdown/style.css";
import classes from "./Header.module.scss";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { headerRoutes } from "../../../router";
import logo from "../../../assets/img/logo-white.svg";
import Button from "../Button/Button";

const languages = [
  { value: "ru", label: "RU" },
  { value: "en", label: "EN" },
  { value: "es", label: "ES" },
  { value: "it", label: "IT" },
  { value: "de", label: "DE" },
  { value: "pl", label: "PL" },
];

const Header = () => {
  const { t } = useTranslation();
  const [burgerOpened, setBurgerOpened] = useState(false);
  const { pathname } = useLocation();
  const { lang } = useParams();
  const navigate = useNavigate();

  const getCurrentPath = () => pathname.replace(`/${lang}`, '').replace(/\/$/, "");

  const getRoute = (route) => {
    if (lang && route) {
      return `/${lang}${route}`;
    }
    return `/${i18n.language}${route}`;
  }

  const setLocale = (newLang) => {
    let newPathname = pathname;
    i18n.changeLanguage(newLang);

    if (lang && newLang) {
      newPathname = pathname.replace(`/${lang}`, `/${newLang}`);
    }

    navigate(newPathname);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setBurgerOpened(false);
    const langs = _.dropRight(i18n.options.supportedLngs);
    if (lang === undefined || !langs.includes(lang)) {
      setLocale("en");
    }
  }, [pathname]);

  useEffect(() => {
    burgerOpened
      ? $("body").addClass("lock")
      : $("body").removeClass("lock");
  }, [burgerOpened]);

  useEffect(() => {
    if ($("body").hasClass("lock")) {
      $("body").removeClass("lock");
    }
    const langs = _.dropRight(i18n.options.supportedLngs);
    if (lang === undefined || !langs.includes(lang)) {
      setLocale("en");
    } else {
      setLocale(lang);
    }
  }, []);

  window.addEventListener("resize", (event) => {
    setBurgerOpened(false);
  });

  return (
    <header className={`${classes.header} ${burgerOpened && classes.headerActive} no-select`}>
      <div className={`container ${classes.container}`}>
        <div className={classes.headerRow}>
          <div className={classes.headerRowLogo}>
            <Link to={`/${lang}/`} onClick={() => setBurgerOpened(false)}>
              <img src={logo} alt="" />
            </Link>
          </div>
          <div className={classes.headerRowLinks}>
            {headerRoutes.map((route, index) => (
              <div key={index} className={classes.item}>
                <Link
                  to={getRoute(route.path)}
                  className={`${route.path === getCurrentPath() ? classes.active : ''}`}
                >
                  {t(route.text)}
                  {route.routes &&
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                      <path d="M0.396973 0.449707L6.06364 5.44971L11.397 0.449707" stroke="#fff" strokeOpacity="0.7" strokeWidth="1.2" />
                    </svg>
                  }
                </Link>
                {route.routes &&
                  <div className={classes.subRoutes}>
                    {route.routes.map((subroute, subIndex) =>
                      <Link
                        key={subIndex}
                        to={getRoute(subroute.path)}
                        className={`${classes.aLink} ${subroute.path === getCurrentPath() ? classes.active : ''}`}
                        onClick={() => setBurgerOpened(false)}
                      >
                        {t(subroute.text)}
                      </Link>
                    )}
                  </div>
                }
              </div>
            ))}
          </div>
          <div className={classes.headerRowRight}>
            {/* <div className={classes.langs}>
              <Dropdown
                options={languages}
                onChange={(e) => setLocale(e.value)}
                value={lang}
                placeholder="EN"
              />
            </div> */}
            <div className={classes.btn}>
              <Button form white>
                {t('btn.contact-us')}
              </Button>
            </div>
            <div
              onClick={() => setBurgerOpened((value) => !value)}
              className={`${classes.burger} ${burgerOpened && classes.burgerActive}`}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div className={`${classes.mobileMenu} ${burgerOpened && classes.mobileMenuActive}`}>
        <div className={classes.mobileContainer}>
          {headerRoutes.map((route, index) => (
            <div key={index}>
              <Link
                to={getRoute(route.path)}
                className={`${classes.aLink} ${route.path === getCurrentPath() ? classes.linkActive : ''}`}
                onClick={() => setBurgerOpened(false)}
              >
                {t(route.text)}
              </Link>
              {route.routes &&
                <div className={classes.subRoutes}>
                  {route.routes.map((subroute, subIndex) =>
                    <Link
                      key={subIndex}
                      to={getRoute(subroute.path)}
                      className={`${classes.aLink} ${subroute.path === getCurrentPath() ? classes.linkActive : ''}`}
                      onClick={() => setBurgerOpened(false)}
                    >
                      {t(subroute.text)}
                    </Link>
                  )}
                </div>
              }
            </div>
          ))}
          {/* <div className={classes.btn}>
            <Button login>Login</Button>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
